export const trackingEvents = {
  LEAVERS_REPORT: {
    DOWNLOAD_FULL_CSV: 'leavers_report.download_full_csv.clicked',
    DOWNLOAD_PAYCIRCLE_CSV: 'leavers_report.download_paycircle_csv.clicked',
    MARK_AS_PROCESSED: 'leavers_report.mark_as_processed.clicked',
    MARK_AS_UNPROCESSED: 'leavers_report.mark_as_unprocessed.clicked',
  },
}
